export const PROJECT_NAME = 'MacBurger Admin';
export const BASE_URL = 'https://api.macburger.kg/public';
// export const BASE_URL = 'http://127.0.0.1:8000';
export const WEBSITE_URL = 'https://macburger.kg';
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin = BASE_URL + '/api/v1/dashboard/admin/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL = BASE_URL + "/";
export const MAP_API_KEY = 'AIzaSyBiohy_1HfSjWgJBKgAs57BAHguyjH6bIU';
export const export_url = BASE_URL + '/storage/';
export const example = BASE_URL + '/';
export const defaultCenter = { lat: 42.87324732782412, lng: 74.61220801534016 };

export const VAPID_KEY = 'BKJy5xzA2X_DpdVfx6i1ci42xQ1UDckkg6RCSl6wv3ACM4r_HQdfC0jxlK03wzVfwqKTb3ZSvxp_5ndbfSHQ6U4';
export const API_KEY = 'AIzaSyCCkVojyMg74X80_JRvXpGfBrY489O6T6M';
export const AUTH_DOMAIN = 'macburger-1c1ba.firebaseapp.com';
export const PROJECT_ID = 'macburger-1c1ba';
export const STORAGE_BUCKET = 'macburger-1c1ba.appspot.com';
export const MESSAGING_SENDER_ID = '689551247435';
export const APP_ID = '1:689551247435:web:b72fb1621ac4dda55825ce';
export const MEASUREMENT_ID = 'G-F1CS287HBG';
export const DYNAMIC_LINK_DOMAIN = '';
export const ANDROID_PACKAGE_NAME = 'com.macburger.customer';
export const IOS_BUNDLE_ID = 'com.macburger.customer';

export const RECAPTCHASITEKEY = '';

export const DEMO_SELLER = 107; // seller_id
export const DEMO_SELLER_UUID = '3566bdf6-3a09-4488-8269-70a19f871bd0'; // seller_id
export const DEMO_SHOP = 501; // seller_id
export const DEMO_DELIVERYMAN = 106; // deliveryman_id
export const DEMO_MANEGER = 114; // maneger_id
export const DEMO_MODERATOR = 297; // moderator_id
export const DEMO_ADMIN = 501; // administrator_id
export const DEMO_WAITER = 108; // waiter_id

export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/svg',
];
